//removeIf(production)
import ClaroluzEnergy from "./claroluz-energy";
import ClaroluzPower from "./claroluz-power";
//removeIf(production)
import FloatWithTwoDecimals from "./float-with-two-decimals";
//endRemoveIf(production)

class ClaroluzOffer {
    public distributor: string;
    public distributorId: number;
    public is2TD: boolean;
    public offersGreenEnergy: boolean;
    public power1: ClaroluzPower;
    public power2: ClaroluzPower;
    public powerTotal: ClaroluzPower;
    public energy1: ClaroluzEnergy;
    public energy2: ClaroluzEnergy | null;
    public energy3: ClaroluzEnergy | null;
    public energyTotal: number;
    public electricalTax: number;
    public electricalTaxPercentage: number;
    public measureDeviceRenting: number;
    public priceTotal: number;
    public priceTotalWithVat: number;
    public vatValue: number;
    public roundedVatValue: number;
    public totalVatValue: number;
    public priceId: number;
    public description: string;
    public shortDescription: string;

    constructor(
        {
            distributor,
            distributorId,
            is2TD,
            offersGreenEnergy,
            power1,
            power2,
            powerTotal,
            energy1,
            energy2,
            energy3,
            energyTotal,
            electricalTax,
            electricalTaxPercentage,
            measureDeviceRenting,
            priceTotal,
            priceTotalWithVat,
            vatValue,
            roundedVatValue,
            totalVatValue,
            priceId,
            description,
            shortDescription
        }: {
            distributor: string;
            distributorId: number;
            is2TD: boolean;
            offersGreenEnergy: boolean;
            power1: ClaroluzPower;
            power2: ClaroluzPower;
            powerTotal: ClaroluzPower;
            energy1: ClaroluzEnergy;
            energy2: ClaroluzEnergy | null;
            energy3: ClaroluzEnergy | null;
            energyTotal: number;
            electricalTax: number;
            electricalTaxPercentage: number;
            measureDeviceRenting: number;
            priceTotal: number;
            priceTotalWithVat: number;
            vatValue: number;
            roundedVatValue: number;
            totalVatValue: number;
            priceId: number;
            description: string;
            shortDescription: string;
        }) {
        this.distributor = distributor;
        this.distributorId = distributorId;
        this.is2TD = is2TD;
        this.offersGreenEnergy = offersGreenEnergy;
        this.power1 = power1;
        this.power2 = power2;
        this.powerTotal = powerTotal;
        this.energy1 = energy1;
        this.energy2 = energy2;
        this.energy3 = energy3;
        this.energyTotal = new FloatWithTwoDecimals(energyTotal).value;
        this.electricalTax = new FloatWithTwoDecimals(electricalTax).value;
        this.electricalTaxPercentage = new FloatWithTwoDecimals(electricalTaxPercentage).value;
        this.measureDeviceRenting = new FloatWithTwoDecimals(measureDeviceRenting).value;
        this.priceTotal = new FloatWithTwoDecimals(priceTotal).value;
        this.priceTotalWithVat = new FloatWithTwoDecimals(priceTotalWithVat).value;
        this.vatValue = vatValue;
        this.roundedVatValue = new FloatWithTwoDecimals(roundedVatValue).value;
        this.totalVatValue = new FloatWithTwoDecimals(totalVatValue).value;
        this.priceId = priceId;
        this.description = description;
        this.shortDescription = shortDescription;
    }
}

//removeIf(production)
export default ClaroluzOffer;
//endRemoveIf(production)